var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"p-5 pt-10 md:pt-16"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"clear--sm"}),_vm._v(" "),_c('h2',{staticClass:"pb-4 pt-20",domProps:{"textContent":_vm._s(_vm.$t('OPTOUT_MESSAGE'))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }